<ng-container *ngIf="inlineEditor else popupEditor">
  <se-alphanumeric-cell-editor-inline
    tabindex="0"
    [value]="value"
    [notAdmissibleChars]="notAdmissibleChars"
    [startEdited]="cellStartEdited"
    [required]="required"
    (formReady)="_onFormReady($event)">
  </se-alphanumeric-cell-editor-inline>
</ng-container>

<ng-template #popupEditor>
  <se-alphanumeric-cell-editor-popup
    tabindex="0"
    [value]="value"
    [notAdmissibleChars]="notAdmissibleChars"
    [required]="required"
    [width]="cellWidth"
    (formReady)="_onFormReady($event)">
  </se-alphanumeric-cell-editor-popup>
</ng-template>
